import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "info" };
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useBanking } from '@/composables/useBanking';
import { useGoals } from '@/composables/useGoals';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import GoalInfoPanel from './elements/GoalInfoPanel.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import WellPanel from './elements/WellPanel.vue';
import MGButton from './elements/MGButton.vue';
import MGDialog from './elements/MGDialog.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'GoalPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getBankingInfo } = useBanking();
        const { getSavingGoal, deleteSavingGoal, clearSavingGoals } = useGoals();
        const goal = ref(null);
        const wellData = ref(null);
        const showDelete = ref(false);
        function deleteGoal() {
            deleteSavingGoal(goal.value.id, () => {
                clearSavingGoals();
                router.push('/Goals');
            });
        }
        function onLoad() {
            getCustomer(() => {
                getBankingInfo(() => {
                    getSavingGoal(route.params.id, (g) => {
                        goal.value = g;
                        goal.value.account = state.bankInfo.accounts.find((a) => a.id == g.bankAccountID);
                        wellData.value = [
                            { order: 0, label: 'Goal', value: goal.value.name },
                            { order: 1, label: 'Account', value: goal.value.account.bank.prettyName + ' ' + goal.value.account.displayName },
                            { order: 2, label: 'Account Balance', value: state.formatter.format(goal.value.account.balance) },
                            { order: 3, label: 'Saved so Far', value: state.formatter.format(goal.value.currentBalance) },
                            { order: 5, label: 'Goal Target', value: state.formatter.format(goal.value.targetAmount) },
                            { order: 6, label: 'Monthly Instalment', value: state.formatter.format(goal.value.instalmentAmount) },
                        ];
                    });
                });
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: goal.value ? goal.value.name + ' Goal' : 'Savings Goal'
                }, null, 8, ["title"]),
                _createVNode(CustomerLoadWait, { customer: goal.value }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (goal.value && goal.value.account)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                (goal.value)
                                    ? (_openBlock(), _createBlock(GoalInfoPanel, {
                                        key: 0,
                                        class: "edged goalInfoPanel",
                                        goal: goal.value.targetAmount,
                                        saved: goal.value.currentBalance,
                                        instalment: goal.value.instalmentAmount,
                                        formatter: _unref(state).formatter
                                    }, null, 8, ["goal", "saved", "instalment", "formatter"]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_2, [
                                    _createVNode(WellPanel, { data: wellData.value }, null, 8, ["data"]),
                                    _createVNode(MGButton, {
                                        icon: "mdi-delete",
                                        text: "Delete Goal",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (showDelete.value = true))
                                    })
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(MGDialog, {
                    modelValue: showDelete.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((showDelete).value = $event)),
                    "max-width": "400",
                    "content-height": "150px",
                    title: "Delete Goal"
                }, {
                    content: _withCtx(() => [
                        _createElementVNode("p", null, "Are you sure you want to delete your " + _toDisplayString(goal.value.name) + " goal?", 1)
                    ]),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            fullWidth: true,
                            onClick: deleteGoal,
                            text: "Delete"
                        }),
                        _createVNode(MGButton, {
                            stacked: true,
                            fullWidth: true,
                            onClick: _cache[1] || (_cache[1] = ($event) => (showDelete.value = false)),
                            outline: true,
                            text: "Cancel"
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ], 64));
        };
    }
});
